<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M40 13.25l-15-9a2.05 2.05 0 00-2.06 0l-15 9A2 2 0 007 15v18a2 2 0 001 1.72l15 9a2.05 2.05 0 002.06 0l15-9A2 2 0 0041 33V15a2 2 0 00-1-1.75zM24 7.17l12.61 7.54-4.75 2.84L19.24 10zm-1.5 32.77L10 32.46V17.38l12.5 7.47zM24 22.25l-12.61-7.54 4.93-3 12.61 7.59zm14 10.21l-12.5 7.48V24.85L38 17.38z"/></svg>